module.exports = __webpack_public_path__ + "static/media/9.Secateurs.feec66cd.jpg";